import {
  CellClickedEvent,
  ColDef,
  ColGroupDef,
  GridOptions,
  GridSizeChangedEvent,
  RowClickedEvent,
  RowDataUpdatedEvent,
  GridApi,
  ColumnApi,
} from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

export const TableTheme = {
  ALPINE: 'ag-theme-alpine',
  ALPINE_DARK: 'ag-theme-alpine-dark',
} as const;

export const TableHeight = {
  NORMAL: 'table-height--normal',
  SHORT: 'table-height--short',
  AUTO: 'table-height--auto',
  FIT_CONTAINER: 'table-height--fit',
  FIT_SCREEN: 'table-height--fit-screen',
  FILL_PARENT: 'table-height--fill-parent',
} as const;

export const TableRowHeight = {
  SMALL: 40,
  NORMAL: 60,
  LARGE: 80,
} as const;

export type TableThemeValue = (typeof TableTheme)[keyof typeof TableTheme];
export type TableHeightValue = (typeof TableHeight)[keyof typeof TableHeight];
export type TableRowHeightValue = (typeof TableRowHeight)[keyof typeof TableRowHeight];

export interface TableProps<T> {
  className?: string;
  columnDefs: (ColDef<T> | ColGroupDef<T>)[];
  dataTestId?: string;
  extraGridOptions?: GridOptions<T>;
  getColumnApi?: (columnApi: ColumnApi) => void;
  getTableApi?: (api: GridApi<T>) => void;
  id?: string;
  localeText?: { noRowsToShow: string };
  onCellClicked?: (event: CellClickedEvent<T>) => void;
  onGridSizeChanged?: (event: GridSizeChangedEvent) => void;
  onRowClicked?: (event: RowClickedEvent<T>) => void;
  onRowDataUpdated?: (event: RowDataUpdatedEvent<T>) => void;
  ref?: React.RefObject<AgGridReact<T>> | null;
  rowData?: T[] | null;
  rowHeight?: TableRowHeightValue;
  suppressMovableColumns?: boolean;
  syncPageIndex?: number;
  tableHeight?: TableHeightValue;
  theme?: TableThemeValue;
}

export interface Pagination {
  currentPage: number;
  totalPages: number;
  totalResults: number;
  startResult: number;
  endResult: number;
}
